<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-12-30 17:55:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/components/Tags/index.vue
-->
<template>
  <div class="clearfix tags">
    <div
      :class="tradeType === 0 ? 'bg_0' : tradeType === 1 ? 'bg_1' : 'bg_2'"
      class="font10 tag_item  colof left"
    >
      {{ tradeType === 0 ? "海外仓" : tradeType === 2 ? "一般贸易" : "保税区" }}
    </div>
    <!-- <div class="font9 tag_item bg_0 colof left">海外仓</div> -->
    <!-- <div class="font9 tag_item bg_2 colof left">一般贸易</div> -->
    <div
      v-if="includeTax === 1 && tradeType !== 2"
      class="font9 tag_item bg_3 left"
    >
      包税
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tradeType: {
      type: Number,
      default: 0
    },
    includeTax: {
      type: Number,
      default: 0
    },
    tradeTypeName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.tags {
  // display: inline-block;
  .tag_item {
    // font-size: 12px;
    line-height: 10px;
    display: inline-block;
    padding: 1px 2px;
    border-radius: 2px;
    margin-right: 4px;
    box-sizing: border-box;
  }
  .bg_0 {
    background: #ab53c4 !important;
    border: 1px solid #ab53c4;
  }
  .bg_1 {
    background: #000;
    border: 1px solid #000;
  }
  .bg_2 {
    background: #bf9264;
    border: 1px solid #bf9264;
  }
  .bg_3 {
    line-height: 11px;
    border: 1px solid #bf9264;
    background: rgba(191, 146, 100, 0.12);
    color: #bf9264;
  }
}
</style>
